import React, { useState, useEffect } from 'react';
import { api } from '../../../common/app';
import { Toast, Button } from 'antd-mobile';
import Layout from '../component/layout'
import { useHistory } from 'react-router-dom'
import Card from '../component/card';
import { useUserStatus } from '../../../common/hooks/user-status';
import moment from 'moment'

export default (props: any) => {
  const { id } = props.match.params;
  const history = useHistory();
  // 酒店数据
  const [data, setData] = useState({} as any);
  const { userstatus } = useUserStatus(id);
  const [loading, setLoading] = useState(true);
  // 请求数据
  useEffect(() => {
    (api as any).myJourney({ meetid: id })
      .then((result: any) => {
        if (result.code === 200) {
          setData(result.result);
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      })
      .catch((err: any) => {
        Toast.fail(err.message || '接口请求失败');
      });
  }, []);

  // 跳转到修改
  const onEdit = (item: any) => {
    history.push(`/mine/joruney/${id}/${item.id}`);
  }
  const renderCard = (cardData: any, canedit: boolean) => {
    return (
        <Card
            edit={canedit && "修改"}
            type={cardData.type === 1 ? "train" : "plane"}
            title={`${cardData.depart_city} --- ${cardData.back_city}`}
            status={`${
                cardData.draw_status === 1
                    ? "出票中"
                    : cardData.draw_status === 2
                    ? "出票成功"
                    : "出票失败"
            }`}
            statusColor={cardData.draw_status !== 2 ? "red" : undefined}
            time={``}
            onClick={() => onEdit(cardData)}
        >
            {cardData.draw_status === 2 && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>出发站点：{cardData.go_train_name}</span>
                    <span>到达站点：{cardData.back_train_name}</span>
                    <span>
                        {`${cardData.type === 1 ? "车次号：" : "航班号："}`}
                        {cardData.train_number}
                    </span>
                    {cardData.train_time_str && (
                        <span>
                            {cardData.draw_status !== 1 && cardData.type === 1
                                ? "车次时间："
                                : "航班时间："}
                            {cardData.draw_status === 1
                                ? `行程日期：${moment(
                                      cardData.depart_time_str
                                  ).format("YYYY-MM-DD")}`
                                : cardData?.train_time_str}
                        </span>
                    )}
                </div>
            )}
            {cardData.draw_status === 1 && (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    {cardData.train_time_str && (
                        <span>
                            {cardData.draw_status === 1
                                ? `行程日期：${moment(
                                      cardData.depart_time_str
                                  ).format("YYYY-MM-DD")}`
                                : cardData?.train_time_str}
                        </span>
                    )}
                </div>
            )}
        </Card>
    );
  }

  return (
    <Layout
      loading={loading}
      meetid={id}
      status={userstatus.is_travel}
      type="trip"
      data={[data.go_data || {}, data.back_data || {}]}
      renderCard={renderCard}
    />
  );
}